import React from "react";
import Card from "components/card";
import { 
  Calendar,
  Clock, 
  MapPin 
} from "lucide-react";
import { formatDateRange } from "utils/index";

const AbsencesCard = (props) => {
  const leave = { ...props };

  return (
    <div className="flex flex-col gap-6">
      <Card
        className="flex flex-col gap-6 rounded-xl border border-slate-200 hover:shadow-md transition-shadow leave dark:border-slate-700"
      >
        <div className="pb-6 p-5">
          <div className="space-y-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-start gap-3 flex-1">
                <span className="relative flex w-12 h-12 shrink-0 overflow-hidden rounded-full">
                  <span className="flex size-full items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                    {leave?.lve_employee_initials}
                  </span>
                </span>

                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h4 className="font-semibold dark:text-white">{leave?.lve_employee_name}</h4>
                    <span className="inline-flex items-center justify-center rounded-xl border px-2 py-0.5 font-medium text-[10px] dark:text-white">
                      {leave?.lve_employee?.emp_code}
                    </span>
                    <span
                      className={`text-[10px] status-indicator ${leave?.lve_state?.toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      {leave?.lve_state}
                    </span>
                  </div>

                  <p className="text-[13px] text-slate-700 dark:text-slate-100">
                    {leave?.lve_employee?.emp_title} • {leave?.lve_employee?.department_name}
                  </p>

                  <div className="flex items-center gap-1 mt-1">
                    <MapPin className="w-3 h-3 text-slate-700 dark:text-slate-100" />
                    <span className="text-[12px] text-slate-700 mr-1 dark:text-slate-100">
                      {leave?.lve_employee?.user_detail?.country_name}
                    </span>
                    <span className="text-[14px]">{}</span>
                  </div>
                </div>
              </div>

              <span
                className={`text-[11px] status-indicator ${leave?.lve_type_name?.toLowerCase().replace(/\s+/g, "-")}`}>
                {leave?.lve_type_name}
              </span>
            </div>

            <div className="h-px w-full bg-slate-200" />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <p className="text-[11px] text-slate-700 mb-1 dark:text-slate-100">
                  Leave Period
                </p>
                <div className="flex items-center gap-2">
                  <Calendar className="w-3 h-3 text-emerald-600" />
                  <span className="text-[13px] font-medium dark:text-white">
                    {formatDateRange(leave?.lve_date_from, leave?.lve_date_to, false)}
                  </span>
                </div>
              </div>

              <div>
                <p className="text-[11px] text-slate-700 mb-1 dark:text-slate-100">
                  Duration
                </p>
                <div className="flex items-center gap-2">
                  <Clock className="w-3 h-3 text-purple-600" />
                  <span className="text-[13px] font-medium dark:text-white">
                    {leave?.lve_duration} day{leave?.lve_duration > 1 ? "s" : ""}
                  </span>
                </div>
              </div>

              <div>
                <p className="text-[11px] text-slate-700 mb-1 dark:text-slate-100">
                  Reason
                </p>
                <span className="text-[13px] font-medium dark:text-white">{leave?.lve_reason}</span>
              </div>
            </div>

            {leave && (
              <div
                className={`rounded-lg p-3 border ${
                  leave.lve_state === "On leave"
                    ? "bg-orange-50 border-orange-200 dark:bg-orange-50/10 dark:border-orange-500"
                    : "bg-emerald-50 border-emerald-200 dark:bg-emerald-50/10"
                }`}
              >
                <p
                  className={`text-[12px] tracking-normal ${
                    leave.lve_state === "On leave"
                      ? "text-orange-800 dark:text-orange-100"
                      : "text-emerald-800 dark:text-emerald-100"
                  }`}
                >
                  <span className="font-semibold">
                    {leave.lve_state === "On leave"
                      ? "Currently unavailable – "
                      : "Scheduled leave – "}
                  </span>
                  {leave.lve_state === "On leave"
                    ? `Expected back on ${formatDateRange(leave.lve_date_to)}`
                    : `Starts on ${formatDateRange(leave.lve_date_from)}`}
                </p>
              </div>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AbsencesCard;